module.exports = __webpack_public_path__ + "components/flag/static/square/az-24d0f5e714705ebb9fe20bd48a3a5e70.svg";